import { useEffect, useState } from "react";

import { defaultReceivingBankInfo, defaultWireInfo } from "../../../utils/constants/form.constants";
import { WireInfo } from "../../../utils/types/investor.type";

export const useWireEffect = (
  investorWireInfo: WireInfo,
  scrollToBottom: any
) => {
  const [wireInfo, setWireInfo] = useState<WireInfo>(defaultWireInfo);
  const [hideIntermediaryInfo, setHideIntermediaryBankInfo] = useState(true);
  const [canScroll, setCanScroll] = useState(false);

  useEffect(() => {
    if (!investorWireInfo) return;
    if (
      !investorWireInfo.receivingBankInfo ||
      investorWireInfo.receivingBankInfo === undefined
    )
      investorWireInfo.receivingBankInfo = defaultReceivingBankInfo;
    setWireInfo(investorWireInfo);
    if (
      investorWireInfo.intermediaryBankInfo &&
      investorWireInfo.intermediaryBankInfo.abaNumber
    )
      setHideIntermediaryBankInfo(false);
  }, [investorWireInfo]);

  useEffect(() => {
    if (canScroll) scrollToBottom();
  }, [hideIntermediaryInfo]);

  return {
    wireInfo,
    hideIntermediaryInfo,
    setHideIntermediaryBankInfo,
    setCanScroll,
  };
};
